import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import Icon from '../components/Icon';
import PageHeader from '../components/PageHeader';
import { PRIMARY } from '../components/CaptureSheets';
import { useApp, useAppPath } from '../lib/AppContext';
import { rememberMode } from '../lib/mode';

const BENEFITS = [
  { icon: 'eye', title: 'Theo dõi nhật ký học viên', text: 'Xem bữa ăn, buổi tập và tiến độ mục tiêu ngay trong app, không cần nhắn hỏi.' },
  { icon: 'qr', title: 'Mã HLV cố định', text: 'Học viên nhập mã hoặc quét QR để kết nối. Miễn phí, không tốn chỗ.' },
  { icon: 'gift', title: 'Tặng Pro cho học viên', text: 'Mua chỗ để tặng Pro qua lời mời một lần. Học viên không phải trả tiền.' },
];

// ① Settings › Dành cho huấn luyện viên: what coach mode offers, and turning it on (free), then the coach's
// onboarding (O3, O4).
export default function CoachIntroPage() {
  const { api, coach, setCoach } = useApp();
  const path = useAppPath();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const enable = async () => {
    setBusy(true);
    setError(null);
    try {
      const data = await api.post('/coach');
      setCoach(data);
      rememberMode('coach');
      navigate(path('/coach/start'), { replace: true });
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Dành cho huấn luyện viên" />
      <section data-theme="macro-dark" className="flex flex-col gap-3 rounded-[24px] bg-base-200 p-6 text-base-content">
        <span className="grid size-12 place-items-center rounded-[14px] bg-[#6fd3a0] text-[#15261f]"><Icon name="users" className="size-6" /></span>
        <h2 className="text-2xl font-extrabold leading-tight">Huấn luyện học viên ngay trong Macro Mate</h2>
        <p className="text-sm text-muted">Chế độ huấn luyện viên miễn phí. Bạn chỉ trả tiền khi muốn tặng Pro cho học viên.</p>
      </section>
      <ul className="flex flex-col gap-3">
        {BENEFITS.map((b) => (
          <li key={b.title} className="flex gap-3 rounded-[20px] bg-base-100 p-4">
            <span className="grid size-10 shrink-0 place-items-center rounded-[12px] bg-[#e3f1e9] text-[#17804f]"><Icon name={b.icon} className="size-5" /></span>
            <span>
              <span className="block font-bold">{b.title}</span>
              <span className="block text-sm text-muted">{b.text}</span>
            </span>
          </li>
        ))}
      </ul>
      {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}
      {coach ? (
        <Link to={path('/coach')} className={PRIMARY}>Mở chế độ HLV</Link>
      ) : (
        <button type="button" className={PRIMARY} disabled={busy} onClick={enable}>
          {busy && <span className="loading loading-spinner loading-sm" />} Bật chế độ HLV · miễn phí
        </button>
      )}
      <Link to={path('/coach/seats')} className="flex h-11 items-center justify-center text-sm font-semibold text-brand-text">
        Xem giá gói tặng Pro
      </Link>
    </div>
  );
}
